/**
 * [pug template]
 */
<template lang="pug">
  div(:class="{ 'olst-field-error': hasError, 'olst-field-warning': hasWarning, 'olst-field-info': hasInfo }")
    div(class="olst-field-dimension")
      label-component.olst-field-label(:name="fieldRef", :text="field.label")
      range-component(:min="minUomized", :max="maxUomized", :uom="uom" v-show="minUomized && maxUomized")
      br
      input-number-component(:name='fieldRef', :defaultValue='cc_value', :min='minUomized', :max='maxUomized', v-on:value-changed="valueChanged", :class="{ 'validation-field-error': hasError, 'validation-field-warning': hasWarning, 'validation-field-info': hasInfo }", :disabled="isFieldDisable()")
      modal(v-if="field.toolTip && field.toolTip.length", :name="fieldRef", :tooltip="field.toolTip")
    .olst-field-validation(v-for="messages, key, index in field.validation", v-if="isValidationMessage(key)")
      div(v-for="message in messages", :class="{ 'olst-field-error': isTypeError(key), 'olst-field-warning': isTypeWarning(key), 'olst-field-infos': isTypeInfo(key) }")
        text-component(:text="__t(message)")
</template>
/**
 * [javascript application]
 */
<script>
import config from '../../config/global'
import {DimensionComputed, DimensionMethods, DimensionWatch} from '../../lib/inherited/dimension'
import { RenderingUnitComputed, RenderingUnitMethods, RenderingUnitWatch } from '../../lib/inherited/rendering_unit.js'

export default {
  name: 'dimension',
  props: {
    fieldRef: {
      type: String,
      default: ''
    },
    productReference: {
      type: String,
      default: null
    },
    version: {
      type: String,
      default: 'default'
    },
    field: {
      type: Object,
      default: { label: '', minValue: 0, maxValue: 100, tooltip: '' }
    },
    cc_value: {
      type: [Number, String],
      default: 0
    },
    uom: {
      type: String,
      default: 'cm'
    },
    mint: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      val_uom: this.cc_value
    }
  },
  components: config.components,
  computed: Object.assign({}, RenderingUnitComputed, DimensionComputed),
  methods: Object.assign({}, RenderingUnitMethods, DimensionMethods),
  watch: Object.assign({}, RenderingUnitWatch, DimensionWatch)
}
</script>
/**
 * [scss styles]
 */
<style lang="scss">
</style>



// WEBPACK FOOTER //
// Dimension.vue?895ffcee